import { render, staticRenderFns } from "./PopWindow.vue?vue&type=template&id=a54c67ca&scoped=true&"
import script from "./PopWindow.vue?vue&type=script&lang=js&"
export * from "./PopWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopWindow.vue?vue&type=style&index=0&id=a54c67ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54c67ca",
  null
  
)

export default component.exports